import { prepareHostedCheckout } from '../lib/hostedCheckout'
import { isSupportedLocale } from '../../../shared/locales.mjs'
export const PAY_NOW_CHANNEL = 'privana_booking_pay_now_handoff'
export const PAY_NOW_STORAGE_EVENT_KEY = 'privana_booking_pay_now_completed'
export const PAY_NOW_HANDOFF_PREFIX = 'privana_booking_pay_now_handoff:'

function safeJson(value) {
  try { return JSON.parse(value) } catch { return null }
}

export function buildBookingSuccessPath({ module, clubCode, bookingId, sportType }) {
  const encodedClub = encodeURIComponent(clubCode || '')
  const encodedBooking = encodeURIComponent(bookingId || '')
  if (module === 'racquet') return `/${encodedClub}/book-racquet/${encodeURIComponent(sportType || 'tennis')}/booking/success?booking_id=${encodedBooking}`
  if (module === 'fitness') return `/${encodedClub}/fitness/booking/success?booking_id=${encodedBooking}`
  if (module === 'spa') return `/${encodedClub}/spa/booking/success?booking_id=${encodedBooking}`
  return `/${encodedClub}/golf/booking/success?booking_id=${encodedBooking}`
}

export function createPayNowHandoff({ module, clubCode, successPath, sportType }) {
  const key = `${PAY_NOW_HANDOFF_PREFIX}${module}:${clubCode}:${Date.now()}:${Math.random().toString(36).slice(2)}`
  const handoff = { key, module, clubCode, sportType: sportType || null, expected_success_path: successPath || null, created_at: new Date().toISOString() }
  try { window.localStorage?.setItem(key, JSON.stringify(handoff)) } catch {}
  return handoff
}

export function updatePayNowHandoff(key, patch = {}) {
  if (!key) return null
  try {
    const current = safeJson(window.localStorage?.getItem(key) || '') || { key }
    const next = { ...current, ...patch, updated_at: new Date().toISOString() }
    window.localStorage?.setItem(key, JSON.stringify(next))
    return next
  } catch { return null }
}

export function openPayNowCheckoutPlaceholder(handoff, { locale } = {}) {
  const url = `/privana-pay/checkout-opening?handoff_key=${encodeURIComponent(handoff?.key || '')}${isSupportedLocale(locale) ? `&lang=${encodeURIComponent(locale)}` : ''}`
  return prepareHostedCheckout(url)
}

export function notifyPayNowCompleted(payload) {
  const event = { type: 'booking_pay_now_completed', ...payload }
  try {
    const channel = new BroadcastChannel(PAY_NOW_CHANNEL)
    channel.postMessage(event)
    channel.close()
  } catch {}
  try { window.localStorage?.setItem(PAY_NOW_STORAGE_EVENT_KEY, JSON.stringify({ ...event, sent_at: Date.now() })) } catch {}
  return event
}

export function subscribePayNowCompleted({ module, clubCode, onCompleted }) {
  const handler = (event) => {
    const data = event?.data || event
    if (data?.type !== 'booking_pay_now_completed') return
    if (module && data.module !== module) return
    if (clubCode && String(data.clubCode) !== String(clubCode)) return
    if (!data.booking_id) return
    window.dispatchEvent(new CustomEvent('members:upcoming-bookings-invalidated'))
    onCompleted?.(data)
  }
  let channel = null
  try {
    channel = new BroadcastChannel(PAY_NOW_CHANNEL)
    channel.onmessage = handler
  } catch {}
  const storageHandler = (event) => {
    if (event.key !== PAY_NOW_STORAGE_EVENT_KEY || !event.newValue) return
    handler(safeJson(event.newValue))
  }
  try { window.addEventListener('storage', storageHandler) } catch {}
  return () => {
    try { if (channel) channel.close() } catch {}
    try { window.removeEventListener('storage', storageHandler) } catch {}
  }
}
